// src/portal-app/shell/kit/LeanHero.js
//
// The capped hero for pattern P2 (Team tab). It answers one question and
// gets out of the way — every pixel it does not use goes to the cards below.
//
// The cap is enforced by the API: there is deliberately NO children slot and
// no free-text body, so a later screen cannot grow this back into the tall
// sparse card the redesign set out to remove (spec §5 P2).
import React from 'react';
import { GlassCard } from '../LiquidGlass';
import { ensureKitCss } from './kitCss';
import { AvatarRow } from './AvatarRow';

export function LeanHero({ label, value, suffix, pill, avatars }) {
    ensureKitCss();

    return (
        <GlassCard veil className="pk-lean" data-testid="lean-hero">
            <div className="pk-lean-top">
                <div className="pk-lean-main">
                    {label && <div className="pk-label">{label}</div>}
                    <div className="pk-lean-figure">
                        <span className="pk-lean-value pk-num">{value}</span>
                        {suffix && <span className="pk-lean-suffix">{suffix}</span>}
                    </div>
                </div>
                {pill && (
                    <span className={`pk-pill pk-pill-${pill.tone || 'muted'}`}>{pill.label}</span>
                )}
            </div>
            {Array.isArray(avatars) && avatars.length > 0 && (
                <div className="pk-lean-avatars">
                    <AvatarRow people={avatars} />
                </div>
            )}
        </GlassCard>
    );
}

export default LeanHero;
